export default __webpack_public_path__ + "static/media/ic-uniswap-bep20.7d35e0dc.svg";